import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Router } from '@angular/router';


declare var $ :any;

@Component({
  selector: 'app-parceiros',
  templateUrl: './parceiros.component.html',
  styleUrls: ['./parceiros.component.css']
})
export class ParceirosComponent extends AbstractComponent implements OnInit {
  
  constructor(
    private sessaoService: SessaoService,
    private router: Router) {
    super(sessaoService);
  }

  ngOnInit() {}

  //parceiroFord() {
    //this.router.navigate(['/login-parceiro',{ cdParceiro: '02_FORD'}]);
  //}

  //parceiroJeep() {
    //this.router.navigate(['/login-parceiro',{ cdParceiro: '03_JEEP'}]);
  //}

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/parceiros/parceiros.component.ts